const downloadFileFromBlob = (resBlob, filename, extension) => {
	// @ts-ignore
	const blob = new Blob([resBlob], { type: extension });
	const element = document.createElement('a');
	element.href = URL.createObjectURL(blob);
	element.download = filename || 'unknown';
	document.body.appendChild(element);
	element.click();
	document.body.removeChild(element);
};

const downloadPdfFileFromBlob = (resBlob, filename) => {
	return downloadFileFromBlob(resBlob, filename, 'application/pdf');
};

export { downloadFileFromBlob, downloadPdfFileFromBlob };
